import Home from './components/home.vue';
import About from './components/about.vue';
import Service from './components/service.vue';
import Gallery from './components/gallery.vue';
import Contact from './components/contact.vue';
import Appointment from './components/adminSection.vue';
import i18n from './i18n';

// import offline from './components/offline.vue'

export const routes = [
	{
		path: '/',
		redirect: `/${i18n.locale}`,
	},
	{
		path: '/:lang',
		component: {
			render(c) {
				return c('router-view');
			},
		},
		children: [
			{ path: '/', component: Home },
			{ path: 'about', component: About },
			{ path: 'service', component: Service },
			{ path: 'gallery', component: Gallery },
			{ path: 'contact', component: Contact },
			{ path: 'admin71833920', component: Appointment },
			{ path: '/:catchAll(.*)', redirect: '/' },
		],
	},
];
